module.exports = __webpack_public_path__ + "static/media/dynamics.fbb84361.png";